module.exports = __webpack_public_path__ + "img/my_zhaochengguo.160cf657.svg";